module.exports = __webpack_public_path__ + "static/media/eye-close.2edd587c.svg";